import React, { useState } from 'react';
import './Home.css';
import Notification from './Notification';

function MinuteOfMeeting() {
  const [menuOpen, setMenuOpen] = useState(false);

  const meetings = [
    {
      id: 1,
      title: 'Minutes of the Meeting of Naturopathy Registration Board (NRB) held on Tuesday, the 28th March, 2023 at 03:00 PM at Ministry of Ayush, New Delhi in Hybrid Mode.',
      date: 'March 28, 2023',
      description: 'A Meeting of Naturopathy Registration Board (NRB) was held on 28/03/2023 at Ministry of Ayush, New Delhi to promote, explore and understand the current status of clinical practices, medical and paramedical education with regard to Naturopathy and to formulate a framework of its regulation. The meeting was chaired by Vaidya Shri Rajesh Kotecha, Secretary, Ministry of Ayush, New Delhi.',
      pdfUrl: '/pdf/NRB_Final_Minutes28032023.pdf',
      icon: '📋'
    },
    {
      id: 2,
      title: 'Minutes of the First Meeting of Registration Committee of Naturopathy Registration Board (NRB) held on Friday, the 7th July, 2023 at 03:00 PM through Virtual Mode.',
      date: 'July 7, 2023',
      description: 'A Meeting of the Registration Committee of Naturopathy Registration Board (NRB) was held on 07/07/2023 through virtual mode to discuss and finalize the process for commencing the registration process. The meeting was chaired by Dr. Babu Joseph, Secretary, Ministry of Ayush, New Delhi.',
      pdfUrl: '/pdf/MOM of First Registration Committee.pdf',
      icon: '📋'
    }
  ];

  return (
    <div className="home">
      {/* Header */}
      <header className="top-header">
        <div className="header-inner">
          <div className="header-logos">
            <a href="/" aria-label="Go to home page">
              <img src="img/nrb.png" alt="Logo 1" className="header-logo-img" />
            </a>
            <a href="https://ayush.gov.in/" target="_blank" rel="noopener noreferrer" aria-label="Open Ministry of Ayush website">
              <img src="img/MOA.png" alt="Logo 2" className="header-logo-img" />
            </a>
          </div>

          <div className="topbar-marquee-group">
            <Notification />
            <Notification
              variant="danger"
              messages={[
                'State registration is mandatory as part of the NRB-HPR integrated registration process. Kindly download the HPR Certificate and I-card from HPR Portal through this link https://nhpr.abdm.gov.in/nhpr/v4/login'
              ]}
            />
          </div>
        </div>
      </header>

      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-inner">
          <button
            className="nav-toggle"
            aria-label="Toggle navigation"
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
          </button>
          <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
            <li><a href="/">Home</a></li>
            <li className="nav-dropdown">
              <a href="#about">About</a>
              <ul className="dropdown-menu">
                <li><a href="/about-us">About NRB</a></li>
                <li><a href="https://ninpune.ayush.gov.in/#!/" target="_blank" rel="noopener noreferrer">About NIN</a></li>
              </ul>
            </li>
            <li><a href="/constitution">Constitution of NRB</a></li>
            <li className="nav-dropdown">
              <a href="#directory">NRB Directory</a>
              <ul className="dropdown-menu">
                <li><a href="/doctors-list">List of Doctors Registered</a></li>
                <li><a href="/naturopathy-centers">Naturopathy Centers in India</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#events">Events</a>
              <ul className="dropdown-menu">
                <li><a href="/minute-of-meeting">Minute of Meeting (MOM)</a></li>
                <li><a href="/gallery">News & Events</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#resources">Resources</a>
              <ul className="dropdown-menu">
                <li><a href="/state-boards">State Registration Board</a></li>
                <li><a href="/medical-colleges">State Wise Yoga & Naturopathy Medical Colleges in India, 2023</a></li>
                <li><a href="/who-naturopathic-workforce">World Health Organisation (WHO) Region wise listing of countries with Naturopathic Workforce 2023</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#others">Others</a>
              <ul className="dropdown-menu">
                <li><a href="/bnys-syllabus">BNYS Syllabus</a></li>
                <li><a href="https://ninpune.ayush.gov.in/#!/nisargopcharVartaArchive" target="_blank" rel="noopener noreferrer">Nisargopchar Varta</a></li>
              </ul>
            </li>
            <li><a href="/contact">Contact</a></li>
            <li className="nav-cta-mobile"><a href="https://app.nrb.net.in/#/session/signin/step1">Register</a></li>
          </ul>
          <a href="https://app.nrb.net.in/#/session/signin/step1" className="nav-cta">Click here to Register</a>
        </div>
      </nav>

      {/* MOM Page Content */}
      <div className="mom-page">
        <div className="mom-hero">
          <h1 className="mom-main-heading">Minute of Meeting</h1>
          <p className="mom-subtitle">Official records of Board Meetings and proceedings</p>
        </div>

        <div className="content-wrapper">
          <div className="mom-container">
            {meetings.map((meeting) => (
              <div key={meeting.id} className="mom-card">
                <div className="mom-card-header">
                  <span className="mom-icon">{meeting.icon}</span>
                  <div className="mom-title-section">
                    <h3 className="mom-title">{meeting.title}</h3>
                    <p className="mom-date">📅 {meeting.date}</p>
                  </div>
                </div>
                
                <div className="mom-card-body">
                  <p className="mom-description">{meeting.description}</p>
                  
                  <div className="mom-pdf-viewer">
                    <embed 
                      src={meeting.pdfUrl} 
                      type="application/pdf" 
                      width="100%" 
                      height="500px"
                    />
                  </div>
                  
                  <div className="mom-actions">
                    <a href={meeting.pdfUrl} className="mom-btn-open" target="_blank" rel="noopener noreferrer">
                      <span>📖 Open in Full Screen</span>
                    </a>
                    <a href={meeting.pdfUrl} className="mom-btn-download" download>
                      <span>📥 Download</span>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section">
            <h3 className="footer-heading">Naturopathy Registration Board</h3>
            <p className="footer-desc">
              Regulating and promoting excellence in Naturopathy education and practice across India.
            </p>
            <div className="footer-logos">
              <img src="img/nrb.png" alt="NRB Logo" className="footer-logo" />
              <img src="img/MOA.png" alt="Ministry Logo" className="footer-logo" />
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/about-us">About NRB</a></li>
              <li><a href="/constitution">Constitution of NRB</a></li>
              <li><a href="/doctors-list">List of Doctors Registered</a></li>
              <li><a href="/naturopathy-centers">Naturopathy Centers in India</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Important Links</h4>
            <ul className="footer-links">
              <li><a href="/minute-of-meeting">Minute of Meeting (MOM)</a></li>
              <li><a href="/gallery">News &amp; Events</a></li>
              <li><a href="/state-boards">State Registration Board</a></li>
              <li><a href="/medical-colleges">Medical Colleges</a></li>
              <li><a href="/who-naturopathic-workforce">WHO Naturopathic Workforce</a></li>
              <li><a href="/bnys-syllabus">BNYS Syllabus</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contact Information</h4>
            <div className="footer-contact">
              <p>Dr Kajal Gupta (Domain Expert), NRB</p>
              <p>📧 nrb@bharatmail.co.in</p>
              <p>📞 86258 33306</p>
              <p>🕐 Mon-Fri: 10:00 AM - 6:00 PM</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Naturopathy Registration Board. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="#privacy">Privacy Policy</a>
            <span>|</span>
            <a href="#terms">Terms & Conditions</a>
            <span>|</span>
            <a href="#sitemap">Sitemap</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default MinuteOfMeeting;


